export const getInfoBanner = (componentData) => {
    const items = {};
    items.bgColor = componentData?.items?.[0]?.backgroundColour;
    items.title = componentData?.items?.[0]?.elementsCollection?.items?.[0]?.title;
    items.subtitle = componentData?.items?.[0]?.elementsCollection?.items?.[0]?.subtitle;
    items.imageTitle = componentData?.items?.[0]?.elementsCollection?.items?.[0]?.image?.title;
    items.imageUrl = componentData?.items?.[0]?.elementsCollection?.items?.[0]?.image?.url;
    items.description = componentData?.items?.[0]?.elementsCollection?.items?.[0]?.description;
    items.buttons = componentData?.items?.[0]?.elementsCollection?.items?.[0]?.ctaLinksCollection?.items?.map(button => {
        return {
            button: {
                label: button?.label,
                type: button?.type,
                url: button?.url
            }
        };
    });

    return items;
};
